import { render } from "./SliderSwiper.vue?vue&type=template&id=5bd92c2d&scoped=true"
import script from "./SliderSwiper.vue?vue&type=script&lang=js"
export * from "./SliderSwiper.vue?vue&type=script&lang=js"

import "./SliderSwiper.vue?vue&type=style&index=0&id=5bd92c2d&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd92c2d"]])

export default __exports__